<template>
  <div class="py-8 px-9">
    <SubmissionsDataTable />
  </div>
</template>

<script>
import SubmissionsDataTable from "@/components/Utils/SubmissionsDataTable.vue";
export default {
  components: {
    SubmissionsDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {},
};
</script>

<style></style>
